import { DebugLevel } from "./types";

export const GRAPHQL_URL = `${process.env.BACKEND_URL}/graphql`;
export const BACKEND_URL = process.env.BACKEND_URL;
export const PAGINATION_LIMIT = 20;
export const AWS_AUTH_CONFIG = {
  Auth: {
    Cognito: {
      userPoolId: process.env.AWS_USER_POOL_ID ?? "",
      userPoolClientId: process.env.AWS_USER_POOL_WEB_CLIENT_ID ?? "",
      loginWith: {
        oauth: {
          domain: process.env.AWS_USER_POOL_CUSTOM_DOMAIN ?? "",
          scopes: ["openid", "aws.cognito.signin.user.admin"],
          redirectSignIn: [process.env.AWS_USER_POOL_CALLBACK_URL ?? ""],
          redirectSignOut: [process.env.AWS_USER_POOL_CALLBACK_URL ?? ""],
          responseType: "code" as const,
        },
      },
    },
  },
};
export const AWS_AUTH_IDP =
  process.env.AWS_USER_POOL_IDENTITY_PROVIDER_NAME ?? "AzureAD";
export const DEBUG = process.env.DEBUG
  ? (process.env.DEBUG as DebugLevel)
  : "*";
export const VERSION = process.env.VERSION ?? "";
export const SENTRY_DSN = process.env.SENTRY_DSN_FRONTEND;
